import { forwardRef } from 'react';
import styled from 'styled-components';
import { FormControlLabel, FormControlLabelProps } from '@mui/material';
import Radio from '../Radio/Radio';

const FormControlLabelStyled = styled(FormControlLabel)<{
  $selected?: boolean;
}>`
  gap: 24px;
  background: ${({ theme, $selected }) =>
    $selected ? theme.palette.common.lightBlue3 : theme.palette.common.white};
  transition: background-color 150ms ease-in-out;
  border-radius: 8px;
  padding: 16px 24px;
  margin: 0;
  &:hover {
    background: ${({ theme }) => theme.palette.common.lightBlue3};
  }
`;

type Props = Omit<FormControlLabelProps, 'control'> & {
  selected: boolean;
};

const LabeledRadioFormField = forwardRef(
  ({ selected, ...props }: Props, ref: any) => (
    <FormControlLabelStyled
      ref={ref}
      $selected={selected}
      control={<Radio />}
      {...props}
    />
  ),
);

export default LabeledRadioFormField;
